import { User } from '@app/models';
import { FilterActions, FilterActionTypes } from '@app/pcs/actions/filter';
import { LabelActions, LabelActionTypes } from '@app/pcs/actions/label';
import { ShareFilterLabelActions, ShareFilterLabelActionTypes } from '@app/pcs/actions/share-filter-label';
import { createHandler, createReducer, reducerWithResetAction } from '@util';
import * as R from 'ramda';

export interface SharedObject {
  sharedObjectId: number;
  sharedObjectType: SharedObjectType;
}

export enum SharedObjectType {
  FILTER = 'filter',
  LABEL = 'label'
}

export interface State {
  eligibleUsersForSharing: User[];
  sharedUsers: User[];
  sharedObject: SharedObject;
  displayShareForm: boolean;
}

export const initialState: State = {
  eligibleUsersForSharing: null,
  sharedUsers: null,
  sharedObject: null,
  displayShareForm: false
};

const setEligibleUsersForSharing = (state: State, {payload: eligibleUsersForSharing}): State =>
  R.mergeRight(state, {
    eligibleUsersForSharing
  });

const setSharedUsers = (state: State, {payload: sharedUsers}): State =>
  R.mergeRight(state, {
    sharedUsers
  });

const setSharedObject = (state: State, {payload: {sharedObjectType, sharedObjectId}}): State =>
  R.mergeRight(state, {
    sharedObject: {
      sharedObjectType,
      sharedObjectId
    }
  });

const hideShareForm = (state: State): State =>
  R.mergeRight(state, {
    displayShareForm: false
  });

const toggleShareForm = (state: State): State =>
  R.evolve({
    displayShareForm: R.not
  }, state);

export const reducer = reducerWithResetAction(
  ShareFilterLabelActionTypes.ResetState,
  createReducer<State, FilterActions | LabelActions | ShareFilterLabelActions>([
    createHandler(ShareFilterLabelActionTypes.FetchEligibleUsersForSharingSuccess, setEligibleUsersForSharing),
    createHandler(ShareFilterLabelActionTypes.FetchSharedUsersSuccess, setSharedUsers),
    createHandler(ShareFilterLabelActionTypes.SetSharedObject, setSharedObject),
    createHandler(FilterActionTypes.SelectFilter, hideShareForm),
    createHandler(LabelActionTypes.SelectLabel, hideShareForm),
    createHandler(ShareFilterLabelActionTypes.ToggleShareForm, toggleShareForm)
  ], initialState));
